import { useSelector } from "react-redux";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { Modal, Box } from '@mui/material';
import './App.css';
import ProtectedRoute from "./protectedRoute";
import ResponsiveAppBar from './ResponsiveAppBar';
// import Home from './routes/home';
import Login from './routes/login';
import SignUp from "./routes/signup";
import SignUpResult from "./routes/signupresult";
import Replenishment from './routes/replenishment';
import ErrorPage from './routes/errorPage';
import YearToYear from "./routes/yearToYear";
import Dashboard from "./routes/dashboard";
import KPIDashboard from "./routes/kpidashboard";
import ConsumerList from "./routes/consumerList";
import QRLocation from "./routes/qrLocation";
import FYourBeauty from "./routes/fYourBeauty";
import CorporateKPI from "./routes/kpis/corporatekpi";
import Orders from "./routes/orders";
import Cart from "./routes/orders/cart";
import OrderList from "./routes/orders/orderList";
import OrderManager from "./routes/orders/orderManager";
import Products from "./routes/products";
import ChangePassword from "./routes/changePassword";
import CRMDashboard from "./routes/crm/crmDashboard";
import SellingRate from "./routes/reports/sellingRate";
import Ecom from "./routes/ecom";
import SalesReports from "./routes/reports/salesReports";
import './styles.css';
import ResponsiveAppBar2 from './ResponsiveAppBar2';
import PhuTran from "./routes/phutran";
import D2CStock from "./routes/reports/d2cStock";
import InternalTransfer from "./routes/demand/internalTransfer";
import Grab from "./routes/grab";
const BASE_NAME = process.env.REACT_APP_BASE_NAME;

function Layout() {
  return (
      <>
        {/* <ResponsiveAppBar /> */}
        <ResponsiveAppBar2 />
        <ProtectedRoute />
        {/* <Footer /> */}
      </>
  );
}

const router = createBrowserRouter([
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/signup/:location',
    element: <SignUp />,
  },
  {
    path: '/signupresult',
    element: <SignUpResult />,
  },
  {
    element: <Layout />, // Protect this route
    children: [
      {
        path: '/', element: <Dashboard />,
        index: true, // This makes HomePage the default child of '/'
      },
      { path: '/home', element: <Dashboard />, },
      { path: '/replenishment', element: <Replenishment /> },
      { path: '/yeartoyear', element: <YearToYear /> },
      { path: '/dashboard', element: <Dashboard /> },
      { path: '/kpidashboard', element: <KPIDashboard /> },
      { path: '/consumerlist', element: <ConsumerList /> },
      { path: '/qrlocation', element: <QRLocation /> },
      { path: '/fyourbeauty', element: <FYourBeauty /> },
      { path: '/corporatekpi', element: <CorporateKPI /> },
      { path: '/orders', element: <Orders /> },
      { path: '/cart', element: <Cart /> },
      { path: '/orderlist', element: <OrderList /> },
      { path: '/ordermanager', element: <OrderManager /> },
      { path: '/products', element: <Products /> },
      { path: '/changepassword', element: <ChangePassword /> },
      { path: '/crmdashboard', element: <CRMDashboard /> },
      { path: '/sellingrate', element: <SellingRate /> },
      { path: '/ecom', element: <Ecom /> },
      { path: '/salesreports', element: <SalesReports /> },
      { path: '/d2cstock', element: <D2CStock /> },
      { path: '/internaltransfer', element: <InternalTransfer /> },
      { path: '/grab', element: <Grab /> },
      { path: '/test', element: <PhuTran /> },
    ],
    errorElement: <><ResponsiveAppBar /><ErrorPage /></>,
  },
], { basename: BASE_NAME });

function App() {
  const openLogin = useSelector(state => state.authUser.openLogin);

  return <>
    <RouterProvider router={router} />
    <Modal
      open={openLogin}
      // onClose={handleClose}
      // aria-labelledby="modal-modal-title"
      // aria-describedby="modal-modal-description"
    >
      <Box className="box-login">
        <Login modal={true}/>
      </Box>
    </Modal>
  </>;
}

export default App;
